"use strict";

exports.__esModule = true;
exports.default = fillSeriesColors;

var _styles = require("../styles");

/**
 * @package
 *
 * A function to handle reuse of default series colors if provided colors does not match series array size.
 * @param {Array<string>} seriesColors - Array of hexadecimal string representation of colors provided by user.
 * @param {number} seriesSize - The length of the series array provided by user.
 *
 * @returns {Array<string>} - Array of hexadecimal string representation of colors.
 */
function fillSeriesColors(seriesColors, seriesSize) {
  if (seriesColors === undefined || !Array.isArray(seriesColors)) {
    throw new Error("must provide a valid seriesColors parameter. Provided:".concat(seriesColors));
  }

  if (seriesSize === undefined || typeof seriesSize !== 'number') {
    throw new Error("must provide a valid seriesSize parameter. Provided:".concat(seriesSize));
  }

  var overflow = seriesSize - seriesColors.length;
  var colorArrSize = _styles.DEFAULT_SERIES_CHART_COLORS.length - 1;
  var defaultColorIndex = 0;

  while (overflow > 0) {
    seriesColors.push(_styles.DEFAULT_SERIES_CHART_COLORS[defaultColorIndex]);

    if (defaultColorIndex === colorArrSize) {
      defaultColorIndex = 0;
    } else {
      defaultColorIndex++;
    }

    overflow--;
  }

  return seriesColors;
}